/**@jsx jsx */
import { navigate } from 'gatsby'
import { Flex, Button, jsx } from 'theme-ui'
import { toURL } from '~/utils/intl/localePrefix'
const ArticleFilterBar = ({ filters, activeFilter, setFilter }) => {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        button: {
          textTransform: 'capitalize',
          color: 'brilliantRose',
          borderRadius: 0,
          backgroundColor: 'transparent',
          ':hover': {
            backgroundColor: 'transparent',
          },
          p: 0,
          height: 'auto',
          fontWeight: 'heading',
          fontSize: 4,
          borderBottom: 'none',
          transition: '0.2s ease',
          ':after': {
            content: '""',
            display: 'block',
            width: '100%',
            // transition: '0.25s cubic-bezier(.45,.97,.48,1.18)',
            transform: 'scale(0)',
            transformOrigin: 'center',
            height: '2px',
            backgroundColor: 'brilliantRose',
          },
          ':not(:last-child)': {
            mr: '30px',
          },
        },
      }}
    >
      <Button
        sx={{
          width: 'auto',
          ':after': {
            position: 'relative',
            top: '-2px',
            transform: !activeFilter ? 'scale(100%) !important' : 'scale(0%)',
          },
        }}
        onClick={() => {
          setFilter(null)
          navigate(toURL('/blog'))
        }}
      >
        All
      </Button>
      {filters.map(filter => (
        <Button
          key={filter}
          sx={{
            width: 'auto',
            ':after': {
              position: 'relative',
              top: '-2px',
              transform:
                activeFilter?.toLowerCase() === filter.toLowerCase()
                  ? 'scale(100%) !important'
                  : 'scale(0%)',
            },
          }}
          onClick={() => {
            setFilter(filter)
            const urlParam = `/blog?${filter.split(' ').join('-')}`
            navigate(toURL(urlParam))
          }}
        >
          {filter.toLowerCase()}
        </Button>
      ))}
    </Flex>
  )
}
export default ArticleFilterBar
